<template lang="pug">
div
  p Vul hier de gegevens in van je website

  v-layout(column)
    label: b Websiteprofiel ingeschakeld?
    v-layout(align-center)
      v-select(
        v-model='data.state',
        :items='websiteStateItems',
        @keydown.enter='$emit("next")',
        required,
        :error-messages='stateValidationErrors',
        @change='$v.data.state.$touch()',
        @blur='$v.data.state.$touch()',
        solo,
        hide-details
        )
      v-tooltip(left)
        v-icon.ml-3.mr-2(color='primary', slot='activator') fa fa-question-circle
        span Uitgeschakelde websites kunnen geen aanvragen ontvangen.<br><br>Websites in test modus kunnen wel aanvragen ontvangen maar zullen niet geëxporteerd worden.

  text-field.mr-0.mt-4(
    v-model='data.name',
    label='Website naam',
    placeholder='Mijn website',
    @keydown.enter='$emit("next")',
    required,
    :error-messages='nameValidationErrors',
    @change='$v.data.name.$touch()',
    @blur='$v.data.name.$touch()'
    )

  v-layout(column)
    label: b Soort product
    v-select(
      v-model='data.productType',
      :items='productTypeItems',
      placeholder='Kies een soort product',
      @keydown.enter='$emit("next")',
      required,
      :error-messages='productTypeValidationErrors',
      @change='$v.data.productType.$touch()',
      @blur='$v.data.productType.$touch()',
      solo
      )

  text-field.mr-0(
    v-model='data.domain',
    label='Domein',
    placeholder='mijnwebsite.com',
    @keydown.enter='$emit("next")',
    required,
    :error-messages='domainValidationErrors',
    @keydown='$v.data.domain.$touch()',
    @blur='$v.data.domain.$touch()',
    :loading='domainLoading && $v.data.domain.validDomain'
    )

  transition(name='slideup')
    v-alert(:value='true', v-if='!isNew && domainChanged', type='warning') Let op! Wanneer je het domein wijzigt, moet je ook de links naar de lease formulieren wijzigen. Als deze nog naar het oude domein verwijzen dan zullen deze niet meer werken.
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { validDomainRegex } from '@/helpers/validation'
import { productTypeItems } from 'dealerfinanceservices-shared/src/helpers/constants'

export default {
  props: {
    value: Object
  },

  data () {
    return {
      data: this.value,

      initialDomain: this.value.domain,
      domainLoading: false,
      domainLoadingDebounceTimer: null,

      productTypeItems,
      websiteStateItems: [
        { text: 'Ingeschakeld', value: 'enabled' },
        { text: 'Uitgeschakeld', value: 'disabled' },
        { text: 'Test Modus', value: 'testmode' }
      ]
    }
  },

  computed: {
    isNew () {
      return this.$route.params.websiteId === 'new'
    },

    domainChanged () {
      return this.initialDomain !== this.data.domain
    },

    nameValidationErrors () {
      const errors = []
      if (!this.$v.data.name.$dirty) return errors
      !this.$v.data.name.required && errors.push('Dit veld is verplicht')
      return errors
    },

    stateValidationErrors () {
      const errors = []
      if (!this.$v.data.state.$dirty) return errors
      !this.$v.data.state.required && errors.push('Dit veld is verplicht')
      return errors
    },

    productTypeValidationErrors () {
      const errors = []
      if (!this.$v.data.productType.$dirty) return errors
      !this.$v.data.productType.required && errors.push('Dit veld is verplicht')
      return errors
    },

    domainValidationErrors () {
      const errors = []
      if (!this.$v.data.domain.$dirty) return errors
      !this.$v.data.domain.required && errors.push('Dit veld is verplicht')
      !this.$v.data.domain.validDomain && errors.push('Domein moet in de volgende vorm zijn: mijnwebsite.com')
      !this.$v.data.domain.domainTaken && !this.domainLoading && errors.push('Dit domein is al in gebruik')
      return errors
    }
  },

  watch: {
    value (v) {
      this.data = v

      this.initialDomain = v.domain
    },

    data: {
      handler: function (v) {
        if (!this.initialDomain) this.initialDomain = v.domain

        this.$emit('input', v)
      },
      deep: true
    },

    '$v.$invalid': {
      handler: function (v) {
        this.$emit('valid', {
          tab: 'tabGeneral',
          valid: !v
        })
      },
      immediate: true
    }
  },

  validations: {
    data: {
      name: {
        required
      },

      state: {
        required
      },

      productType: {
        required
      },

      domain: {
        required,
        validDomain: (v) => validDomainRegex.test(v),
        domainTaken: async function (v) {
          clearTimeout(this.domainLoadingDebounceTimer)

          if (this.initialDomain === v) return true
          if (!this.$v.data.domain.validDomain) return true

          this.domainLoading = true
          this.$v.data.domain.$reset()

          return new Promise(async (resolve, reject) => {
            this.domainLoadingDebounceTimer = setTimeout(async () => {
              if (!this.$v.data.domain.validDomain) {
                return resolve(false)
              }

              const taken = await this.$store.dispatch('graphqlQuery', { name: 'isDomainTaken', variables: { domain: v } })

              this.domainLoading = false

              return resolve(!taken)
            }, 1000)
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
